<script>
import { mapGetters } from "vuex"

export default {
    name: "Auth",
    computed: {
        ...mapGetters("reduxi", {
            siteInfo: "getSiteInfo",
        }),
        logoUrl() {
            let savedLogo = this.$store.getters["reduxi/getSiteLogo"]

            if (savedLogo !== null && savedLogo.length > 0) {
                return savedLogo
            }

            return require(`@/assets/brands/${this.$brand}/images/logo.svg`)
        },
        supportUrl() {
            return this.siteInfo.links.support
        },
        termsAndConditionsUrl() {
            return this.siteInfo.links.termsAndConditions
        },
        privacyPolicyUrl() {
            return this.siteInfo.links.privacyPolicy
        },
    },
    mounted() {
        document.body.classList.add("public")
    },
    destroyed() {
        document.body.classList.remove("public")
    },
}
</script>

<template>
    <main>
        <div class="public-container">
            <div class="logo-container">
                <router-link :to="{ path: '/' }">
                    <img :src="logoUrl" class="logo" alt="logo" />
                </router-link>
            </div>
            <div class="inner-content" style="overflow-x: hidden; overflow-y: auto">
                <router-view />
            </div>
        </div>

        <div class="policy">
            <a :href="privacyPolicyUrl" target="_blank">{{ $t("Privacy Policy") }}</a>
            |
            <a :href="termsAndConditionsUrl" target="_blank">{{ $t("Terms and Conditions") }}</a>
            |
            <a :href="supportUrl" target="_blank">{{ $t("Support") }}</a>
        </div>
    </main>
</template>
